export default __webpack_public_path__ + "static/media/show-umbrella-1.c38ee24f.webp";